<template>
	<div class="watch-readings-details-menu">
		<button @click="buttonClick(1)" :class="isActive(1)">Measure</button>
		<button @click="buttonClick(2)" :class="isActive(2)">Latest</button>
		<button @click="buttonClick(3)" :class="isActive(3)">History</button>
	</div>
</template>

<script>
export default {
	data () {
		return {
			active: 1
		}
	},
	methods: {
		buttonClick (index) {
			this.active = index
			this.$emit('selected', this.active)
		},
		isActive (index) {
			return this.active == index ? 'active' : ''
		},
		onHighlightReading () {
			this.active = 3;
			this.$emit('selected', this.active)
		}
	},
	created () {
		this.$root.$on('biometric-details-highlight-latest-reading', this.onHighlightReading)
	},
	beforeDestroy () {
		this.$root.$off('biometric-details-highlight-latest-reading', this.onHighlightReading)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/ReadingsDetailsSubMenu.vue